const routes = [
  {
    path: '/sesion',
    name: 'Sesiones',
    component: () => import('@/views/forms/Sesion.vue')
  },
  {
    path: '/sesionerr',
    name: 'Sesiones Error',
    component: () => import('@/views/forms/SesionErr.vue')
  },
  {
    path: '/accesosesion',
    name: 'Acceso Sesión',
    component: () => import('@/views/forms/AccesoSesion.vue')
  },
  {
    path: '/sesionesmes',
    name: 'Sesiones por Mes',
    component: () => import('@/views/dashboards/admin/SesionesMes.vue')
  },
  {
    path: '/sesionesdia',
    name: 'Sesiones por Día',
    component: () => import('@/views/dashboards/admin/SesionesDia.vue')
  }
];

export { routes };
